import UsersCardsContainer from "../../../../Components/Applications/Users/UsersCards/UsersCardsContainer";

const UsersCards = () => {
  return <UsersCardsContainer />;
};

export default UsersCards;
